<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import Image from '../components/image.svelte';
	import type { SbImage } from '../types';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			icon: SbImage;
			label: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<article
	use:editable={content}
	class="flex h-full flex-col items-center justify-center gap-y-3 p-2"
>
	<Image
		src={content.icon.filename}
		alt={content.icon.alt}
		title={content.icon.title}
		wrapperClass="flex items-center justify-center h-[85px]"
		class="object-contain"
	/>
	{#if content.label?.length > 0}
		<h1 class="flex-1 text-center text-[14px]/[140%] text-brown-1">{content.label}</h1>
	{/if}
</article>
